module.exports = __webpack_public_path__ + "img/Singapore.85212085.png";